import React from 'react';
// logic
import useTicketsList from '../components/ticketsList/useTicketsList';
import useTicketsFilters from '../components/ticketsList/useTicketsFilters';
// components
import PortalContent from '../components/ui/portal/portalContent';
import TicketsList from '../components/ticketsList/ticketsList';
import TicketsListToolbar from '../components/ticketsList/ticketsListToolbar';

const TicketsListPage = () => {
  const filtersData = useTicketsFilters();
  const { selectedFilters } = filtersData;
  const ticketsListData = useTicketsList({ selectedFilters });

  // hidding this because with the new filters, the last bar is too small
  // const { lastUpdate } = ticketsListData;

  return (
    <>
      <PortalContent>
        <TicketsListToolbar
          // lastUpdate={lastUpdate}
          filtersData={filtersData}
        />
      </PortalContent>
      <TicketsList ticketsListData={ticketsListData} />
    </>
  );
};

export default TicketsListPage;
